module.exports = __webpack_public_path__ + "static/img/b1.0e1b1ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/b1.png
// module id = cd6w
// module chunks = 0